import { Base, Component, Mixins, Prop } from '@/vue-property-decorator'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { Icon } from '@/plugins/ant-design-vue/tsx-support'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useMainStore } from '@/store/index'
import BasePropsConfig, { LandscapeProps } from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain from '../../components/maskMaintain'
import style from './style.module.scss'
export interface Props extends LandscapeProps {
  /** 是否图标背景 (PS:当前不知道该属性是什么意思,原来就有,所以直接保留)*/
  isIconBackGround?: boolean
  /** 平台宣传语 */
  description?: string
  /** 尺寸大小 */
  mySize?: 'default' | 'small'
}
type Events = {
  click: () => void
}
/** 游戏卡片
 * 正方型图片,结合文字
 */
@Component<GalaxyLandscape>({
  name: 'GalaxyLandscape'
})
// export default class GalaxyLandscape extends  Base<unknown, Props, Events> {
export default class GalaxyLandscape extends Mixins<
  Base<unknown, Props, Events>,
  BasePropsConfig
>(Base, BasePropsConfig) {
  /** 通过传入原始数据,获取props  */
  public static getProps = BasePropsConfig.getProps
  @Prop({ default: false })
  private isIconBackGround!: Props['isIconBackGround']
  @Prop({ default: 'default' })
  private mySize!: Required<Props>['mySize']
  private hover = false
  /** 渲染卡片外部整个包裹内容 */
  private renderCardWrapper(baseContent: VueTsxSupport.JSX.Element) {
    const { status, isMaintain, mySize, isAtSwiper, atSwiperDomId } = this
    const { isWeb } = useMainStore()
    return (
      // 最外层的这个div,其主要还是预留给list盒子操作它的样式
      <div
        class={style['landscape-left-right']}
        onMouseenter={() => (this.hover = true)}
        onMouseleave={() => (this.hover = false)}
      >
        {/* item-main 才是主要样式开始的地方 */}
        <my-img
          options={{
            type: 'div',
            lazy: !isAtSwiper,
            immediate: isAtSwiper
          }}
          src=""
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          class={{
            [style['item-main']]: true,
            [style[`size-${mySize}`]]: true,
            [style['item-main-gaming']]:
              this.categoryId === GameCategoryIds.Gaming,
            [style['item-main-sport']]:
              this.categoryId === GameCategoryIds.Sports,
            [style['item-main-lottery']]:
              this.categoryId === GameCategoryIds.Lottery,
            [style['border-active']]:
              this.categoryId === GameCategoryIds.Lottery && this.hover,
            [style['bg-active']]:
              this.categoryId === GameCategoryIds.Sports && this.hover
          }}
          onClick={() => this.$emit('click')}
        >
          {/* 放置在box-cut中的元素会被裁剪为圆角 */}
          <BoxCut
            cssVarManagerMust={{
              '--box-cut-border-radius': isWeb ? '0' : '0.2rem',
              '--box-cut-border-width': isWeb ? '0' : '2px',
              '--box-cut-box-shadow': isWeb
                ? 'none'
                : 'var(--theme-aside-box-shadow)'
            }}
          >
            {baseContent}
            <template slot="cutSuspense">
              {/* 游戏状态标签 */}
              <LabelGameStatus
                status={status}
                class={style['label-game-status']}
              />

              {/* 维护状态悬浮层 */}
              {isMaintain && <MaskMaintain />}
            </template>
          </BoxCut>
        </my-img>
      </div>
    )
  }

  private renderGamingContent() {
    const { gameName, imgUrl, logoUrl, isIconBackGround } = this

    return (
      /* 主体内容不悬浮的 */
      <div
        class={{
          [style['main-content-gaming']]: true,
          [style['assembled-box']]: true,
          [style['icon-back-ground']]: isIconBackGround as boolean
        }}
      >
        {/* 广告图位置 */}
        <my-img
          options={{ type: 'div' }}
          src="/lobby_asset/{layout}-{bg}-{skin}/web/home/img_dt_dj_ddt.png"
          class={style['introduce-gaming']}
        >
          <my-img
            class={style['advertisement-image']}
            src={imgUrl}
            options={{ type: 'div' }}
          />
        </my-img>
        {/* 内容是文案部分 */}
        <div
          class={{
            [style['introduce-content-gaming']]: true,
            [style['introduce-content-gaming-hover']]: this.hover
          }}
        >
          <div
            class={{
              [style['gaming-warp']]: true
            }}
          >
            <div
              class={{
                [style['gaming-image']]: true
              }}
            >
              {logoUrl && (
                <my-img
                  width={46}
                  height={46}
                  class={style['logo']}
                  src={logoUrl}
                  options={{ type: 'div' }}
                />
              )}
              <div
                class={[style['name'], this.hover ? style['hover-name'] : '']}
              >
                {gameName}
              </div>
              <Icon.Tsx
                class={{
                  [style.arrow]: true,
                  [style['arrow-hover']]: this.hover
                }}
                component={{
                  functional: true,
                  render() {
                    return (
                      <icon-sprite sprite={createSvgSprite('icon_dt_dj_go')} />
                    )
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  private renderRealContent() {
    const {
      gameName,
      description,
      imgUrl,
      logoUrl,
      isJackpot,
      isIconBackGround
    } = this

    return (
      /* 主体内容不悬浮的 */
      <div
        class={{
          [style['main-content']]: true,
          [style['assembled-box']]: true,
          [style['icon-back-ground']]: isIconBackGround as boolean
        }}
      >
        {/* 广告图位置 */}
        <my-img
          options={{ type: 'div' }}
          src="/lobby_asset/{layout}-{bg}-{skin}/web/home/img_dt_zr_ddt.png"
          class={style['introduce-right']}
        >
          <my-img class={style['advertisement-image']} src={imgUrl} />
        </my-img>
        {/* 内容是文案部分 */}
        <div class={style['introduce-left']}>
          <icon-sprite
            class={{ [style.icon]: true, [style['icon-hover']]: this.hover }}
            sprite={createSvgSprite('btn_zr')}
          />
          <div
            class={{
              [style['copywriting']]: true,
              [style['show-bonus-pool']]: isJackpot as boolean
            }}
          >
            <div class={style['headline']}>
              {logoUrl && <my-img class={style['logo']} src={logoUrl} />}
              <div
                class={[style['name'], this.hover ? style['hover-name'] : '']}
              >
                {gameName}
              </div>
            </div>
            <div class={style['description']}>{description}</div>
          </div>
        </div>
      </div>
    )
  }

  private renderLotteryContent() {
    const { gameName, imgUrl, logoUrl, isIconBackGround } = this

    return (
      /* 主体内容不悬浮的 */
      <div
        class={{
          [style['introduce-content-lottery']]: true,
          [style['assembled-box']]: true,
          [style['icon-back-ground']]: isIconBackGround as boolean
        }}
      >
        {/* 广告图位置 */}
        <my-img
          options={{ type: 'div' }}
          src="/lobby_asset/{layout}-{bg}-{skin}/web/home/img_dt_cp_ddt.png"
          class={style['introduce-lottery']}
        >
          <my-img class={style['advertisement-image']} src={imgUrl} />
        </my-img>
        {/* 内容是文案部分 */}
        <div
          class={{
            [style['content-lottery']]: true
          }}
        >
          <div
            class={{
              [style['lottery-warp']]: true
            }}
          >
            <div class={[style['name'], this.hover ? style['hover-name'] : '']}>
              {gameName}
            </div>
            {logoUrl && (
              <my-img width={46} class={style['logo']} src={logoUrl} />
            )}
          </div>
        </div>
      </div>
    )
  }

  private renderSportContent() {
    const { gameName, imgUrl, logoUrl, isIconBackGround } = this

    return (
      /* 主体内容不悬浮的 */
      <div
        class={{
          [style['introduce-content-sport']]: true,
          [style['assembled-box']]: true,
          [style['icon-back-ground']]: isIconBackGround as boolean
        }}
      >
        {/* 广告图位置 */}
        <my-img
          options={{ type: 'div' }}
          src="/lobby_asset/{layout}-{bg}-{skin}/web/home/bg_ty_rktb.png"
          class={style['introduce-sport']}
        >
          <my-img class={style['advertisement-image']} src={imgUrl} />
        </my-img>
        {/* 内容是文案部分 */}
        <div
          class={{
            [style['content-sport']]: true
          }}
        >
          <div
            class={{
              [style['sport-warp']]: true
            }}
          >
            {logoUrl && (
              <my-img width={46} class={style['logo']} src={logoUrl} />
            )}
            <div class={[style['name'], this.hover ? style['hover-name'] : '']}>
              {gameName}
            </div>
          </div>
        </div>
      </div>
    )
  }
  /** 渲染卡片内基础内容 */
  private renderContent() {
    const { categoryId } = this

    if (categoryId === GameCategoryIds.Real) {
      return this.renderRealContent()
    } else if (categoryId === GameCategoryIds.Gaming) {
      return this.renderGamingContent()
    } else if (categoryId === GameCategoryIds.Lottery) {
      return this.renderLotteryContent()
    } else if (categoryId === GameCategoryIds.Sports) {
      return this.renderSportContent()
    }
    return this.renderGamingContent()
  }

  render() {
    return this.renderCardWrapper(this.renderContent())
  }
}
